import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { UserI } from '../modele/types';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  u: UtilsService = inject(UtilsService);

  http: HttpClient = inject(HttpClient);
  r: Router = inject(Router);

  // profil: AuteurI = {
  //   nom: '',
  //   prenom: '',
  //   email: ''
  // };
  user?: UserI;
  connecte: boolean = false;

  constructor(){
    if(sessionStorage.getItem('u')) {
      this.user = JSON.parse( sessionStorage.getItem('u')! );
      this.r.navigateByUrl('/edition');
    };
  }

  /** Identifier un utilisateur */
  getID(u: UserI) {
    this.http.post<UserI>(environment.API + 'connexion', u).subscribe({
      next: (p) => {
        this.user = p;
        this.connecte = true;
        sessionStorage.setItem('u', JSON.stringify(this.user));
        this.r.navigateByUrl('/edition');
      },
      error: (e) => this.u.setMsg("Problème de connexion, merci de rééssayer plus tard", "attention"),
      complete: () => this.u.setMsg("Bienvenue", "valide")
    })
  }
  deconnexion(){
    // this.profil = {
    //   nom: '',
    //   prenom: '',
    //   email: ''
    // };
    this.user = undefined;
    sessionStorage.removeItem('u');
    this.r.navigateByUrl('/');
  }
}
